<template>
	<div class="sch-workers">
		<h3 v-if="count">Выберите сотрудника</h3>
		<div class="sch-workersItem" v-for="item in workers" :key="item.id">
			<label class="radio" :class="item.id === workers_id ? 'radio_active' : ''" v-if="count">
				<input
					class="radio-input"
					type="radio"
					name="workers_id"
					@change="input(item)"
					:value="item.id"
					:checked="item.id === workers_id"
				/>
				{{ item.name }} {{ item.surname }}
			</label>
			<slot v-if="workers_id === item.id"></slot>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';

export default {
	props: ['items', 'workers_id', 'anychoice'],
	computed: {
		workers() {
			let list = {};
			if (this.anychoice)
				list['0'] = {
					id: '0',
					name: 'Любой сотрудник',
					surname: '',
				};

			_.each(this.items, ({ workers_id, wname, surname }) => {
				if (typeof list[workers_id] === 'undefined')
					list[workers_id] = {
						id: workers_id,
						name: wname,
						surname: surname,
					};
			});

			// if (Object.keys(list).length < 3) {
			// 	delete list['0'];
			// }

			return list;
		},
		count() {
			return Object.keys(this.workers).length;
		},
		exists() {
			return this.$store.state.schedule.exists;
		},
	},
	created() {
		//if (this.count > 0) this.$emit('input', _.find(this.workers, () => true).id);
	},
	methods: {
		input(item) {
			this.$emit('input', item.id);
		},
	},
};
</script>
